const config = {
    //apiUrl: "http://87.106.3.31:18000",  //http://api3e.soluzioni-it.eu/
    //apiUrl: "https://changes.adviceweb.it/api",  //http://api3e.soluzioni-it.eu/
    
    apiUrl: "https://changes-admin.adviceweb.it//api",
    //apiUrl: "http://192.168.5.146:8000",  //http://api3e.soluzioni-it.eu/
    external_services: {
        //qgis: "http://192.168.36.56:8091/ows",
        qgis: "https://changes.adviceweb.it/ows",
        prjpath : "/srv/projects/sicilia_bim/sicilia_bim.qgs",
        //reactgis:"http://localhost:5173/map"
        reactgis:"https://changes.adviceweb.it/lizmap/"
    },
    api: {
        geocoder: "/api/geocoder",
        getIFC: "/api/ifc/file/",
        getCapabilities: "/api/qgis/services/get_capabilities"
    },
    appName: "Changes - Back Office Platform - ;-)",
    author: "gMox soluzioni-it.eu",
    debugMode: true,
};

    
  export const getProfileFromToken = () => {
    const token = localStorage.getItem("token"); // Recupera il token salvato
    if (!token) {
        console.error("Nessun token trovato");
        return null;
    }
    try {
        // Decodifica il token da Base64 a stringa JSON
        const decodedString = atob(token);
        const tokenData = JSON.parse(decodedString);
        return tokenData.profilo; // Ritorna solo il profilo
    } catch (error) {
        console.error("Errore nella decodifica del token:", error);
        return null;
    }
  };
  
    export const Llogout = () => {
        localStorage.setItem("token",""); // Recupera il token salvato
    
  };
  export default config;
  